module.exports = __webpack_public_path__ + "static/02-273142c21e421aa524528b49476daebe.jpeg";